module.exports = __webpack_public_path__ + "static/media/leaderboard.0723844a.jpeg";